/** Mi cuenta (fase 2, W4). Se mezcla en `conta` del núcleo. Tono: tú. */
export const contaEs = {
  titulo: 'Mi cuenta',
  kicker: 'Cuenta',
  perfil: 'Perfil',
  nome: 'Nombre',
  email: 'Correo',
  aparencia: 'Apariencia e idioma',
  rotuloAbas: 'Secciones de la cuenta',
  abas: { perfil: 'Perfil', aparencia: 'Apariencia', notificacoes: 'Notificaciones', seguranca: 'Seguridad', 'meus-dados': 'Mis datos' },
  salvarNome: 'Guardar nombre',
  nomeSalvo: 'Nombre actualizado',
  nomeVazio: 'Escribe tu nombre',
  iniciais: 'Iniciales de {{nome}}',
  avatar: {
    escolher: 'Elegir foto',
    trocar: 'Cambiar foto',
    remover: 'Quitar foto',
    ajustar: 'Ajustar la foto',
    salvar: 'Guardar foto',
    descartar: 'Descartar',
    salva: 'Foto actualizada',
    removida: 'Foto quitada; vuelven las iniciales',
    processando: 'Procesando la foto...',
    resultado: 'Así aparece la foto en el sistema. Guarda para cambiarla.',
    resultadoAlt: 'Vista previa de la foto nueva',
    removerTitulo: '¿Quitar la foto?',
    removerTexto: 'Vuelven las iniciales de tu nombre. Puedes elegir otra foto cuando quieras.',
    tipoInvalido: 'Elige una imagen PNG, JPG o WebP. SVG y otros formatos no se aceptan.',
    grandeDemais: 'Archivo de más de 20 MB. Elige una imagen más pequeña.',
    naoAbriu: 'No se pudo abrir esta imagen. Elige otro archivo.',
    recorte: {
      area: 'Área de recorte de la foto',
      ajuda: 'Arrastra la foto o usa las flechas (con Shift avanza más); la rueda del ratón y las teclas + y - cambian el zoom. El círculo es solo una guía para centrar el rostro.',
      zoom: 'Zoom',
      saida: 'Sale con {{largura}} × {{altura}} px',
      usar: 'Usar este recorte',
      cancelar: 'Cancelar',
      falhou: 'No se pudo generar la imagen en este navegador. Prueba otro archivo u otro navegador.',
    },
  },
  entrada: {
    titulo: 'Cómo ingresas',
    entraCom: 'Ingresa con:',
    formas: { ambos: 'correo o nombre de usuario, y contraseña', email: 'correo y contraseña', usuario: 'nombre de usuario y contraseña' },
    senhaTexto: 'La contraseña es tuya: la cambias tú.',
    senhaLink: 'Cambiar la contraseña en Seguridad',
    trocaTexto: 'El correo y el nombre de usuario los cambia el administrador del workspace: tú haces la solicitud y él la aprueba o rechaza.',
    trocaTextoDireta: 'Tu correo lo cambias tú mismo, con la contraseña actual. El nombre de usuario lo cambia el administrador del workspace: tú haces la solicitud y él la aprueba o rechaza.',
    trocaTextoDiretaTudo: 'Tu correo y tu nombre de usuario los cambias tú mismo, con la contraseña actual.',
    semDecisor: 'Tu cuenta también está en otro workspace y nadie aquí puede aprobar el cambio del correo o del nombre de usuario: pide el cambio al administrador de la plataforma.',
    acessoLink: 'Cambiarlos en Seguridad',
    emailLink: 'Cambiar el correo en Seguridad',
    pedirEmail: 'Pedir un correo nuevo',
    pedirAdicionarEmail: 'Pedir que se agregue un correo',
    pedirUsuario: 'Pedir un nombre de usuario nuevo',
    enviarPedido: 'Enviar solicitud',
    pedidoEnviado: 'Solicitud enviada al administrador',
    pedidoCancelado: 'Solicitud cancelada',
    cancelarPedido: 'Cancelar solicitud',
    aguardando: 'Esperando al administrador',
    status: { aprovado: 'Aprobada', recusado: 'Rechazada' },
    pedido: { email: 'Correo nuevo: {{valor}}', usuario: 'Nombre de usuario nuevo: {{valor}}' },
    motivo: 'Motivo: {{motivo}}',
    modal: {
      email: {
        titulo: 'Pedir un correo nuevo',
        texto: 'El administrador recibe la solicitud. Si la aprueba, enviamos un enlace de confirmación al correo nuevo; el cambio solo vale después de que abras el enlace.',
        campo: 'Correo nuevo',
        ajuda: 'El correo actual recibe un aviso cuando se pide el cambio y cuando se confirma.',
      },
      usuario: {
        titulo: 'Pedir un nombre de usuario nuevo',
        texto: 'El administrador recibe la solicitud. Si la aprueba, el nombre cambia al instante y ingresas con él.',
        campo: 'Nombre de usuario nuevo',
        ajuda: 'De 2 a 40 letras sin acento, números, punto, guion o guion bajo, sin "@".',
      },
    },
  },
  tour: { titulo: 'Recorrido del sistema', texto: 'Muestra otra vez el recorrido por las áreas principales.', botao: 'Ver el recorrido de nuevo' },
  acessos: {
    titulo: 'Mis accesos',
    texto: 'Lo que tus roles permiten en este workspace, por módulo.',
    textoSubsistemas: 'Lo que tus roles abren en este workspace, por subsistema que usas y página.',
    vazio: 'Todavía no tienes permisos en este workspace. Habla con el administrador.',
    modulos_one: '{{count}} módulo',
    modulos_other: '{{count}} módulos',
  },
  notificacoes: {
    titulo: 'Notificaciones',
    texto: 'Las preferencias de notificación tienen su propia pantalla, que llega con el centro de avisos.',
  },
  fonte: {
    titulo: 'Fuente del texto',
    texto: 'Elige la fuente del texto solo para ti. Los números y valores siguen en la fuente de ancho fijo, para que las columnas no se desalineen.',
    doWorkspace: 'La del workspace',
    doWorkspaceNome: 'La del workspace ({{nome}})',
    doEstiloNome: 'La del estilo ({{nome}})',
    sistema: 'Fuente del sistema',
    enviada: 'Enviada por el administrador',
    bloqueada: 'El administrador definió la misma fuente para todos en este workspace.',
    amostra: 'Acción rápida: código Il1O0, 25 ítems, 98,5%, ñ ¿ ¡',
    facilLer: 'Más fácil de leer',
    escala: 'Tamaño del texto',
    escalaAjuda: 'Agranda todo el texto de la pantalla, para leer con más comodidad.',
    salva: 'Preferencia guardada',
  },
  estilo: {
    titulo: 'Estilo',
    texto: 'Elige el aspecto del sistema solo para ti. Marea, Hielo y Malgo traen los colores de la marca; los otros estilos cambian esquinas, fuente, efectos, profundidad y sombras, inspirados en design systems públicos.',
    seguirPadrao: 'Predeterminado del workspace',
    fixado: 'El administrador definió el estilo {{nome}} para tu cuenta.',
    bloqueado: 'El administrador definió el mismo estilo para todos en este workspace: {{nome}}.',
    padrao: 'Predeterminado',
    nomes: {
      mare_malgo: 'Marea',
      gelo: 'Hielo',
      malgo: 'Malgo (actual)',
      proprio: 'Modelo propio',
      cupertino: 'Cupertino (inspirado en Apple)',
      mare: 'Navy (inspirado en RD Station)',
      redmond: 'Redmond (inspirado en Microsoft)',
      mountain_view: 'Mountain View (inspirado en Google)',
      armonk: 'Armonk (inspirado en IBM)',
      embarcadero: 'Embarcadero (inspirado en Salesforce)',
      sydney: 'Sydney (inspirado en Atlassian)',
      grafite: 'Grafite (inspirado en GitHub)',
      ottawa: 'Ottawa (inspirado en Shopify)',
    },
    salvo: 'Estilo guardado',
  },
  simples: {
    titulo: 'Modo simple',
    ajuda: 'Oculta las pestañas y los campos avanzados, y deja solo lo que se usa a diario. No se borra nada y puedes desactivarlo cuando quieras.',
    desligado: 'Desactivado',
    ligado: 'Activado',
  },
  seguranca: {
    senha: {
      titulo: 'Contraseña',
      atual: 'Contraseña actual',
      nova: 'Contraseña nueva',
      confirmar: 'Confirmar contraseña nueva',
      ajuda: 'Usa al menos 10 caracteres. Al cambiarla, los otros dispositivos salen de la cuenta.',
      trocar: 'Cambiar contraseña',
      diferentes: 'Las contraseñas no coinciden',
      trocada_zero: 'Contraseña cambiada. Ningún otro dispositivo tenía la cuenta abierta.',
      trocada_one: 'Contraseña cambiada. {{count}} dispositivo más salió de la cuenta.',
      trocada_other: 'Contraseña cambiada. {{count}} dispositivos más salieron de la cuenta.',
    },
    mfa: {
      titulo: 'Verificación en dos pasos',
      texto: 'Además de la contraseña, el inicio de sesión pide un código de 6 dígitos de la aplicación de autenticación (Google Authenticator, Microsoft Authenticator, 1Password u otra).',
      ativa: 'Activa',
      inativa: 'Desactivada',
      obrigatoria: 'Tu rol exige la verificación en dos pasos. Configúrala antes del {{data}}.',
      obrigatoriaAgora: 'Tu rol exige la verificación en dos pasos. Configúrala ahora para continuar.',
      lembreteLogin: 'Tu rol exige la verificación en dos pasos. Configúrala antes del {{data}} en Mi cuenta > Seguridad.',
      obrigatoriaAtiva: 'Obligatoria para tu rol',
      ativar: 'Activar',
      passo1: 'Escanea el código QR con la aplicación de autenticación.',
      passo1Alt: '¿Sin cámara? Escribe esta clave en la aplicación:',
      passo2: 'Escribe el código de 6 dígitos que muestra la aplicación.',
      codigo: 'Código de la aplicación',
      codigoOuBackup: 'Código de la aplicación o de respaldo',
      confirmarAtivar: 'Confirmar y activar',
      encerrarOutras: 'Cerrar las otras sesiones (los otros dispositivos vuelven a entrar con el código)',
      qrRotulo: 'Código QR para la aplicación de autenticación',
      chave: 'Clave',
      backupsTitulo: 'Códigos de respaldo',
      backupsTexto: 'Guarda estos códigos en un lugar seguro. Cada uno vale una vez, para entrar sin el celular. No vuelven a aparecer.',
      copiarCodigos: 'Copiar códigos',
      guardei: 'Ya guardé los códigos',
      backupsRestantes_one: '{{count}} código de respaldo disponible',
      backupsRestantes_other: '{{count}} códigos de respaldo disponibles',
      novosBackups: 'Generar nuevos códigos de respaldo',
      novosBackupsTexto: 'Los códigos anteriores dejan de valer. Escribe un código de la aplicación para confirmar.',
      trocarAparelho: 'Cambiar de dispositivo',
      trocarAparelhoTexto: 'Escribe un código de la aplicación actual. Después, escanea el nuevo código QR en el dispositivo nuevo.',
      desativar: 'Desactivar',
      desativarTexto: 'Escribe un código de la aplicación o un código de respaldo para desactivar.',
      ativada: 'Verificación en dos pasos activada',
      desativada: 'Verificación en dos pasos desactivada',
      continuar: 'Continuar',
    },
    sessoes: {
      titulo: 'Sesiones activas',
      texto: 'Dispositivos con tu cuenta abierta ahora.',
      esteAparelho: 'Este dispositivo',
      sair: 'Cerrar sesión en este dispositivo',
      sairTodos: 'Cerrar sesión en todos los demás dispositivos',
      sairTodosTexto: 'Los demás dispositivos salen de la cuenta al instante. Este sigue abierto.',
      ultimoUso: 'Último uso: {{quando}}',
      desconhecido: 'Dispositivo desconocido',
      movel: 'celular',
      ip: 'IP {{ip}}',
      soEste: 'Solo este dispositivo tiene la cuenta abierta.',
      encerrada: 'Dispositivo desconectado',
      encerradas_zero: 'Ningún otro dispositivo tenía la cuenta abierta',
      encerradas_one: '{{count}} dispositivo desconectado',
      encerradas_other: '{{count}} dispositivos desconectados',
    },
    acesso: {
      titulo: 'Acceso a la cuenta',
      texto: 'Entras con el correo o con el nombre de usuario, siempre con la misma contraseña. La cuenta es la misma en todas las empresas en las que trabajas.',
      usuario: 'Nombre de usuario',
      email: 'Correo',
      semEmail: 'Sin correo',
      semEmailTexto: 'Sin correo, la recuperación de la contraseña y de la verificación en dos pasos es con el administrador, y los avisos de seguridad llegan en Notificaciones.',
      trocarEmail: 'Cambiar correo',
      adicionarEmail: 'Agregar correo',
      emailNovo: 'Correo nuevo',
      emailNovoAjuda: 'Le enviamos un enlace. El cambio solo vale después de la confirmación; el correo actual recibe un aviso.',
      emailInvalido: 'Ingresa un correo válido',
      enviar: 'Enviar enlace de confirmación',
      enviado: 'Si la dirección se puede usar, le enviamos el enlace. El cambio solo vale después de la confirmación.',
      trocarUsuario: 'Cambiar nombre de usuario',
      usuarioNovo: 'Nombre de usuario nuevo',
      usuarioNovoAjuda: 'De 2 a 40 letras sin tilde, números, punto, guion o guion bajo, sin "@". Vale al instante; el nombre actual deja de funcionar.',
      usuarioInvalido: 'El nombre de usuario no puede tener "@"',
      salvarUsuario: 'Guardar nombre de usuario',
      usuarioTrocado: 'Nombre de usuario cambiado',
    },
    trocaObrigatoria: {
      titulo: 'Cambia la contraseña provisoria',
      texto: 'La contraseña que recibiste del administrador vale solo para el primer acceso. Elige tu contraseña para continuar. Tu nombre de usuario: {{usuario}}.',
    },
    forcada: {
      titulo: 'Configura la verificación en dos pasos',
      texto: 'Tu rol exige un segundo paso al iniciar sesión. Configúrala ahora para seguir usando el sistema.',
    },
  },
};
